/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { GeneralFeedbackCommentBase } from './GeneralFeedbackCommentBase';
import { InlineFeedbackCommentBase } from './InlineFeedbackCommentBase';
const CommentBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['inline-feedback', InlineFeedbackCommentBase],
    ['general-feedback', GeneralFeedbackCommentBase],
]);
export const CommentBase = CommentBaseParser;
